<template>
    <div class="border-t border-gray h-24 flex">
        <swiper
            :initial-slide="1"
            :space-between="40"
            :loop="true"
            :modules="modules"
            :observer="true"
            navigation
            class="relative z-0 flex-grow py-3 px-10"
            @slideChange="slideSelected"
        >
            <swiper-slide
                v-for="group in visibleGroups"
                :key="group"
            >
                <swiper-list-item
                    :item-data="group"
                    role="button"
                    :disabled="this.disableEdit && group.name !== 'Size & Width'"
                    :class="{ 'opacity-50' : this.disableEdit && group.name !== 'Size & Width' }"
                    @click="openGroupOverlay(group)"
                />
            </swiper-slide>
        </swiper>

        <base-overlay
            :is-open="showGroupOverlay"
            @overlayClose="showGroupOverlay = false"
        >
            <template v-slot:header>
                <h1
                    v-if="selectedGroup"
                    class="flex-1 text-center text-base font-bold"
                >
                    {{ selectedGroup.name }}
                </h1>

                <apply-button
                    :group-name="selectedGroup?.name"
                    @click="showGroupOverlay = false"
                />
            </template>

            <template v-slot:content>
                <step-options
                    v-if="selectedGroup"
                    :item-data="selectedGroup"
                />
            </template>
        </base-overlay>
    </div>
</template>

<script>
    /* eslint-disable import/no-unresolved */
    /* eslint-disable no-unused-vars */
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { Navigation } from 'swiper';
    import 'swiper/css';

    import allStores from '../stores/all';

    import SwiperListItem from './SwiperListItem.vue';
    import BaseOverlay from './BaseOverlay.vue';
    import StepOptions from './StepOptions.vue';
    import ApplyButton from './ApplyButton.vue';

    export default {
        mixins: [allStores],

        components: {
            Swiper,
            SwiperSlide,
            SwiperListItem,
            BaseOverlay,
            StepOptions,
            ApplyButton,
        },

        data() {
            return {
                selectedGroup: null,
                showGroupOverlay: false,
                modules: [Navigation],
            };
        },

        computed: {
            visibleGroups() {
                return this.customizerStore.visibleGroups;
            },

            selectionWasMade() {
                return this.customizerStore.selectionsMade.includes(this.selectedGroup?.name);
            },

            disableEdit() {
                return this.customizerStore.disableEdit;
            },
        },

        methods: {
            openGroupOverlay(group) {
                if (!this.disableEdit || group.name === 'Size & Width') {
                    this.selectedGroup = group;
                    this.showGroupOverlay = true;

                    // Set currentView to the selected group's view in the background while overlay is open
                    setTimeout(() => {
                        this.customizerStore.setCurrentViewByGroup(group);
                    }, 800);
                }
            },

            slideSelected(swiper) {
                const group = this.visibleGroups[swiper.realIndex];

                if (group) {
                    this.customizerStore.setCurrentViewByGroup(group);
                }
            },
        },
    };
</script>

<style>
    #cz3 .swiper-button-prev,
    #cz3 .swiper-button-next {
        z-index: 10;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 100%;
        background-color: white;
        color: black;
    }

    #cz3 .swiper-button-prev {
        left: 0;
    }
    #cz3 .swiper-button-prev::after {
        content: url(@/assets/images/icons/arrow-left.svg);
        height: 20px;
    }

    #cz3 .swiper-button-next {
        right: 0;
    }
    #cz3 .swiper-button-next::after {
        content: url(@/assets/images/icons/arrow-right.svg);
        height: 20px;
    }
</style>
